var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-badge',{attrs:{"variant":_vm.badgeColor}},[_vm._v(" "+_vm._s(_vm.badgeDisplayText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }